import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSocial } from '../rtk/slices/social-slice';

function Contact () {
    const { t, i18n } = useTranslation();

    const dispatch = useDispatch();
    const social = useSelector((state) => state.social.social);

    useEffect(() => {
        dispatch(fetchSocial())

        if (sessionStorage.getItem("lang")) {
            i18n.changeLanguage(sessionStorage.getItem("lang"))
        }
        const inputField = document.querySelectorAll('.myInput');

        inputField.forEach((input) => {
            input.addEventListener('input', function () {
                if (input.value) {
                    // إذا كان هناك نص في الحقل
                    input.style.color = '#fff'; // تعيين اللون إلى الأخضر
                } else {
                    // إذا كان الحقل فارغًا
                    input.style.color = 'initial'; // إعادة تعيين اللون إلى القيمة الافتراضية
                }
            });
        })
    }, [])

    return (
        <section className='contact' id='contact' style={{ backgroundColor: 'var(--bg-color) !important' }}>
            <div className="container">
                <h2 className="title">
                    <span>{i18n.language == "ar" ? "اتصل بنا" : "Contact Us"}</span>
                    <p>{i18n.language == "ar" ? "اتصل بنا" : "Contact Us"}</p>
                </h2>

                <div className="contact-content">
                    <form action={`${process.env.REACT_APP_PROJECTS_API}components/insert_message.php`} method='post' >
                        <div className="input-box">
                            <div className="input-field" style={{ width: "100%" }}>
                                <div className="icon"><i class="fa fa-user"></i></div>
                                <input className='myInput' name='name' type="text" placeholder={i18n.language == "ar" ? "الاسم بالكامل" : "Name"} required />
                            </div>
                        </div>

                        <div className="input-box">
                            <div className="input-field">
                                <div className="icon"><i class="fa fa-phone"></i></div>
                                <input className='myInput' name='phone' type="phone" placeholder={i18n.language == "ar" ? "رقم الهاتف" : "Phone"} required />
                            </div>
                            <div className="input-field">
                                <div className="icon email"><i class="fa fa-envelope"></i></div>
                                <input className='myInput' name='email' type="email" placeholder={i18n.language == "ar" ? "البريد الالكتروني" : "Email"} required />
                            </div>
                        </div>

                        <div className="textarea-field">
                            <div className="icon message"><i class="fa fa-comment"></i></div>
                            <textarea className='myInput' name="message" cols={30} rows={10} placeholder={i18n.language == "ar" ? "الرسالة" : "Message"} required></textarea>
                        </div>

                        <div className="btn-box btns">
                            <button type='submit' name='send' class="button type1">
                                <span class="btn-txt"><a>{i18n.language == "ar" ? "ارسال" : "Send"}</a></span>
                            </button>
                        </div>
                    </form>

                    <div className="contact-content">
                        {social.map(link => {
                            return (
                                <div className="contact-social">
                                    {link.facebook.length > 2 &&
                                        <span>
                                            <a href={link.facebook} target='_blank' class="btn-sosial">
                                                <span class="svgContainer">
                                                </span>
                                                <i class="fa fa-facebook-f"></i>
                                                <span class="BG-social"></span>
                                            </a>
                                        </span>
                                    }

                                    {link.whatsapp.length > 2 &&
                                        <span>
                                            <a href={`https://api.whatsapp.com/send?phone=2${link.whatsapp}`} target='_blank' class="btn-sosial">
                                                <span class="svgContainer">
                                                </span>
                                                <i class="fa fa-whatsapp"></i>
                                                <span class="BG-social"></span>
                                            </a>
                                        </span>
                                    }

                                    {link.instagram.length > 2 &&
                                        <span>
                                            <a href={link.instagram} target='_blank' class="btn-sosial">
                                                <span class="svgContainer">
                                                </span>
                                                <i class="fa fa-instagram"></i>
                                                <span class="BG-social"></span>
                                            </a>
                                        </span>
                                    }


                                    {link.linkedin.length > 2 &&
                                        <span>
                                            <a href={link.linkedin} target='_blank' class="btn-sosial">
                                                <span class="svgContainer">
                                                </span>
                                                <i class="fa fa-linkedin"></i>
                                                <span class="BG-social"></span>
                                            </a>
                                        </span>
                                    }

                                    {link.youtube.length > 2 &&
                                        <span>
                                            <a href={link.youtube} target='_blank' class="btn-sosial">
                                                <span class="svgContainer">
                                                </span>
                                                <i class="fa fa-youtube"></i>
                                                <span class="BG-social"></span>
                                            </a>
                                        </span>
                                    }


                                    {link.tiktok.length > 2 &&
                                        <span>
                                            <a href={link.tiktok} target='_blank' class="btn-sosial">
                                                <span class="svgContainer">
                                                </span>
                                                <i><svg fill='#fff' height={"1rem"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z" /></svg></i>
                                                <span class="BG-social"></span>
                                            </a>
                                        </span>
                                    }



                                </div>
                            )
                        })}
                    </div>

                    <div className="map">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3483.153622580215!2d30.912312484904746!3d29.189603782201324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjnCsDExJzIyLjYiTiAzMMKwNTQnMzYuNSJF!5e0!3m2!1sar!2seg!4v1730413781846!5m2!1sar!2seg"></iframe>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Contact
